import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-shared-button',
  templateUrl: './shared-button.component.html',
  styleUrls: ['./shared-button.component.scss'],
})
export class SharedButtonComponent {
  @Input() button_cta?: string;
  @Input() button_cta_class?: string;
  @Input() button_class?: string = 'hmn-button__main';
  @Output() button_click: EventEmitter<void> = new EventEmitter<void>();
}
